import { useMutation, useQuery } from "@tanstack/react-query";
import CorrectionLinkService, {
  type RequestContactUpdateLinkDto,
  type RequestContactUpdateLinkResponse,
  type SubmitContactUpdateDto,
  type SubmitContactUpdateResponse,
} from "@/services/correction-link/correction-link.service";

export const useValidateCorrectionLink = (token: string | null) => {
  return useQuery({
    queryKey: ["correction-link", "validate", token],
    queryFn: () => CorrectionLinkService.validateLink(token!),
    enabled: !!token,
    retry: false,
  });
};

export const useRequestContactUpdateLink = () => {
  return useMutation<
    RequestContactUpdateLinkResponse,
    Error,
    RequestContactUpdateLinkDto
  >({
    mutationFn: (dto) => CorrectionLinkService.requestContactUpdate(dto),
  });
};

export const useSubmitContactUpdate = (token: string | null) => {
  return useMutation<SubmitContactUpdateResponse, Error, SubmitContactUpdateDto>({
    mutationFn: (dto) =>
      CorrectionLinkService.submitContactUpdate(token as string, dto),
  });
};
